import "../edit.css";
import { useState } from "react";
import { EyeOutline, EyeSlashOutline } from "../../../assets";
import { Input } from "../input";
import { PasswordProps } from "./password.props";

export const Password: React.FC<PasswordProps> = (props) => {
  const [showPass, setShowPass] = useState<boolean>(false);

  return (
    <Input
      {...props}
      type={showPass ? "text" : "password"}
      actions={{
        right: {
          show: true,
          icon: showPass ? EyeSlashOutline : EyeOutline,
          onClick() {
            setShowPass(!showPass);
          },
          disabled: false,
        },
      }}
    />
  );
};
